
import * as trackingEvents from "./index";

export type ValidationResult = { success: true} | { success: false, message: string };
type ValidationFunction = (o: any) => ValidationResult;

export function validateTrackingEvent(eventData: { eventId: number }): ValidationResult {
    let validate: ValidationFunction;
    switch (eventData.eventId) {

    
        case trackingEvents.AllianceCreate.ID:
          validate = trackingEvents.AllianceCreate.validateEvent;
          break;
        
        case trackingEvents.AllianceDiplomacy.ID:
          validate = trackingEvents.AllianceDiplomacy.validateEvent;
          break;
        
        case trackingEvents.AllianceDelete.ID:
          validate = trackingEvents.AllianceDelete.validateEvent;
          break;
        
        case trackingEvents.AllianceMemberChange.ID:
          validate = trackingEvents.AllianceMemberChange.validateEvent;
          break;
        
        case trackingEvents.AlliancePayment.ID:
          validate = trackingEvents.AlliancePayment.validateEvent;
          break;
        
        case trackingEvents.AreaRuin.ID:
          validate = trackingEvents.AreaRuin.validateEvent;
          break;
        
        case trackingEvents.AreaAbandon.ID:
          validate = trackingEvents.AreaAbandon.validateEvent;
          break;
        
        case trackingEvents.AreaRelocate.ID:
          validate = trackingEvents.AreaRelocate.validateEvent;
          break;
        
        case trackingEvents.BattleMeta.ID:
          validate = trackingEvents.BattleMeta.validateEvent;
          break;
        
        case trackingEvents.BattleShadow.ID:
          validate = trackingEvents.BattleShadow.validateEvent;
          break;
        
        case trackingEvents.ColossusDepositEvent.ID:
          validate = trackingEvents.ColossusDepositEvent.validateEvent;
          break;
        
        case trackingEvents.CraftingEquipment.ID:
          validate = trackingEvents.CraftingEquipment.validateEvent;
          break;
        
        case trackingEvents.CrusadeDungeon.ID:
          validate = trackingEvents.CrusadeDungeon.validateEvent;
          break;
        
        case trackingEvents.DailyQuests.ID:
          validate = trackingEvents.DailyQuests.validateEvent;
          break;
        
        case trackingEvents.DisassembleRubyBuilding.ID:
          validate = trackingEvents.DisassembleRubyBuilding.validateEvent;
          break;
        
        case trackingEvents.FinishedEvents.ID:
          validate = trackingEvents.FinishedEvents.validateEvent;
          break;
        
        case trackingEvents.GlobalFactionState.ID:
          validate = trackingEvents.GlobalFactionState.validateEvent;
          break;
        
        case trackingEvents.LongTermPointEventTotalPoints.ID:
          validate = trackingEvents.LongTermPointEventTotalPoints.validateEvent;
          break;
        
        case trackingEvents.LuckyWheelSpin.ID:
          validate = trackingEvents.LuckyWheelSpin.validateEvent;
          break;
        
        case trackingEvents.MessageSent.ID:
          validate = trackingEvents.MessageSent.validateEvent;
          break;
        
        case trackingEvents.MinuteSkips.ID:
          validate = trackingEvents.MinuteSkips.validateEvent;
          break;
        
        case trackingEvents.PaymentRewardGrant.ID:
          validate = trackingEvents.PaymentRewardGrant.validateEvent;
          break;
        
        case trackingEvents.PlayerVIP.ID:
          validate = trackingEvents.PlayerVIP.validateEvent;
          break;
        
        case trackingEvents.PrimeDaySeen.ID:
          validate = trackingEvents.PrimeDaySeen.validateEvent;
          break;
        
        case trackingEvents.ResourcesOnLogout.ID:
          validate = trackingEvents.ResourcesOnLogout.validateEvent;
          break;
        
        case trackingEvents.SentPlayerGift.ID:
          validate = trackingEvents.SentPlayerGift.validateEvent;
          break;
        
        case trackingEvents.Sabotage.ID:
          validate = trackingEvents.Sabotage.validateEvent;
          break;
        
        case trackingEvents.UnitsDismissed.ID:
          validate = trackingEvents.UnitsDismissed.validateEvent;
          break;
        
        case trackingEvents.UnitsStarving.ID:
          validate = trackingEvents.UnitsStarving.validateEvent;
          break;
        
        case trackingEvents.WishingWellCoins.ID:
          validate = trackingEvents.WishingWellCoins.validateEvent;
          break;
        
        case trackingEvents.ClientFunnel.ID:
          validate = trackingEvents.ClientFunnel.validateEvent;
          break;
        
        case trackingEvents.GuestRegistration.ID:
          validate = trackingEvents.GuestRegistration.validateEvent;
          break;
        
        case trackingEvents.MvTestDisplay.ID:
          validate = trackingEvents.MvTestDisplay.validateEvent;
          break;
        
        case trackingEvents.Connection.ID:
          validate = trackingEvents.Connection.validateEvent;
          break;
        
        case trackingEvents.MvTestConversion.ID:
          validate = trackingEvents.MvTestConversion.validateEvent;
          break;
        
        case trackingEvents.ForumRegistration.ID:
          validate = trackingEvents.ForumRegistration.validateEvent;
          break;
        
        case trackingEvents.ClientLoad.ID:
          validate = trackingEvents.ClientLoad.validateEvent;
          break;
        
        case trackingEvents.WorldAssignment.ID:
          validate = trackingEvents.WorldAssignment.validateEvent;
          break;
        
        case trackingEvents.Profiling.ID:
          validate = trackingEvents.Profiling.validateEvent;
          break;
        
        case trackingEvents.GamePaymentshopClick.ID:
          validate = trackingEvents.GamePaymentshopClick.validateEvent;
          break;
        
        case trackingEvents.Impression.ID:
          validate = trackingEvents.Impression.validateEvent;
          break;
        
        case trackingEvents.RUMPerformance.ID:
          validate = trackingEvents.RUMPerformance.validateEvent;
          break;
        
        case trackingEvents.LPJourney.ID:
          validate = trackingEvents.LPJourney.validateEvent;
          break;
        
        case trackingEvents.InGamePerformance.ID:
          validate = trackingEvents.InGamePerformance.validateEvent;
          break;
        
        case trackingEvents.Invitation.ID:
          validate = trackingEvents.Invitation.validateEvent;
          break;
        
        case trackingEvents.FacebookConnection.ID:
          validate = trackingEvents.FacebookConnection.validateEvent;
          break;
        
        default:
            return { success: false, message: 'No validator for given event.' };
    }

    return validate(eventData);
}